import { Linkedin, Facebook, MessageCircle, Link2, Share2 } from "lucide-react";
import { toast } from "sonner";
import { SITE_URL } from "@/lib/seo";

const XIcon = ({ size = 16 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M18.244 2H21.5l-7.5 8.57L22.5 22h-6.9l-5.4-7.06L3.9 22H.64l8.02-9.17L.5 2h7.07l4.88 6.45L18.244 2Zm-1.21 18h1.8L7.05 3.9H5.12L17.03 20Z" />
  </svg>
);

export const ShareButtons = ({ path, title }) => {
  const url = `${SITE_URL}${path}`;
  const enc = encodeURIComponent(url);
  const text = encodeURIComponent(title);
  const links = [
    { id: "linkedin", label: "LinkedIn", icon: Linkedin, href: `https://www.linkedin.com/sharing/share-offsite/?url=${enc}` },
    { id: "facebook", label: "Facebook", icon: Facebook, href: `https://www.facebook.com/sharer/sharer.php?u=${enc}` },
    { id: "x", label: "X", icon: XIcon, href: `https://twitter.com/intent/tweet?url=${enc}&text=${text}` },
    { id: "whatsapp", label: "WhatsApp", icon: MessageCircle, href: `https://wa.me/?text=${text}%20${enc}` },
  ];

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      toast.success("Link copiato negli appunti");
    } catch {
      toast.error("Impossibile copiare il link");
    }
  };

  const native = async () => {
    try {
      await navigator.share({ title, url });
    } catch {}
  };

  const btn = "w-10 h-10 border border-[#262626] flex items-center justify-center text-white/65 hover:text-[#FACC15] hover:border-[#FACC15] transition-colors";
  return (
    <div className="flex flex-wrap items-center gap-3" data-testid="share-buttons">
      <span className="text-xs tracking-[0.2em] uppercase text-white/45 mr-1">Condividi</span>
      {links.map(({ id, label, icon: Icon, href }) => (
        <a key={id} href={href} target="_blank" rel="noopener noreferrer" aria-label={`Condividi su ${label}`} className={btn} data-testid={`share-${id}`}>
          <Icon size={16} />
        </a>
      ))}
      <button type="button" onClick={copy} aria-label="Copia link" className={btn} data-testid="share-copy">
        <Link2 size={16} />
      </button>
      {typeof navigator !== "undefined" && navigator.share && (
        <button type="button" onClick={native} aria-label="Condividi" className={btn} data-testid="share-native">
          <Share2 size={16} />
        </button>
      )}
    </div>
  );
};

export default ShareButtons;
